export default __webpack_public_path__ + "static/help_06_03-1-c0c4320a3bb7bd5db680fa5055005e8c.png";